import { __decorate, __metadata } from "tslib";
import { IsEmail, MaxLength, MinLength, Validate } from 'class-validator';
import { IS_EMAIL_DEFAULT_OPTIONS, IsLatinExtendedName } from '../../shared/validator';
export const NAME_MIN_LENGTH = 1;
// Based off the max length at time of writing being 50
export const NAME_MAX_LENGTH = 75;
/**
 * Request that the system Update a new user
 */
export class UpdateUserRequest {
    constructor(email, givenName, familyName) {
        this.email = email;
        this.givenName = givenName;
        this.familyName = familyName;
    }
}
__decorate([
    IsEmail(IS_EMAIL_DEFAULT_OPTIONS),
    __metadata("design:type", String)
], UpdateUserRequest.prototype, "email", void 0);
__decorate([
    Validate(IsLatinExtendedName),
    MinLength(NAME_MIN_LENGTH),
    MaxLength(NAME_MAX_LENGTH),
    __metadata("design:type", String)
], UpdateUserRequest.prototype, "givenName", void 0);
__decorate([
    Validate(IsLatinExtendedName),
    MinLength(NAME_MIN_LENGTH),
    MaxLength(NAME_MAX_LENGTH),
    __metadata("design:type", String)
], UpdateUserRequest.prototype, "familyName", void 0);
